// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2pdQ5","emails":"CreateEditClinics_emails__18aSj","emailTagLabel":"CreateEditClinics_emailTagLabel__1eXc4"};